import { useAppSelector } from '@src/redux/hooks.ts';
import { SHARE_BINDING_STATUS, SOCIAL_KEY } from '@src/constants/FJShareSocialConstant.ts';
import FJYoutubeView from '@src/components/FJModals/FJShareModal/FJShareContent/target/FJYoutubeView.tsx';
import FJPublishManager from '@src/manager/publish/FJPublishManager.ts';
import { useEffect, useState } from 'react';
import FJMessageStore from '@src/store/FJMessageStore';
import FJLocalStore from '@src/store/FJLocalStore';
import FJRequirementsUtil from '@src/util/FJRequirementsUtil';

const FJYoutubeContainer = () => {
    const isShow = useAppSelector(state => state.share.isShow);
    const userInfo = useAppSelector(state => state.share.youtube);
    const selectedShareTypes: (typeof SOCIAL_KEY)[keyof typeof SOCIAL_KEY][] = useAppSelector(
        state => state.share.selectedShareTypes,
    );

    const [defaultTitle, setDefaultTitle] = useState('');
    const [defaultDescription, setDefaultDescription] = useState('');
    const [defaultPrivacyState, setDefaultPrivacyState] = useState('');

    const [isLoadingText, setIsLoadingText] = useState(false);
    const [isLoadingDescription, setIsLoadingDescription] = useState(false);

    const isSelected = isShow && selectedShareTypes.includes(SOCIAL_KEY.YOUTUBE);

    useEffect(() => {
        if (isSelected) {
            const target = FJPublishManager.getPublishTarget(SOCIAL_KEY.YOUTUBE);
            if (target) {
                setDefaultTitle(target.title);
                setDefaultDescription(target.description);
                setDefaultPrivacyState(target.privacyState);
            }
        }
    }, [isSelected]);

    const onCreateDescription = () => {
        if (isLoadingDescription) {
            return;
        }
        setIsLoadingDescription(true);
        FJRequirementsUtil.eaLog('ai_rewrite_click', { platform: SOCIAL_KEY.YOUTUBE, location: 'description' });
        FJPublishManager.getTextData(SOCIAL_KEY.YOUTUBE, ['caption', 'hashtags'])
            .then(() => {
                const target = FJPublishManager.getPublishTarget(SOCIAL_KEY.YOUTUBE);
                if (target) {
                    setDefaultDescription(target.description);
                }
            })
            .catch(e => {
                if (e.message === '403') {
                    FJMessageStore.addMessage(FJLocalStore._('get-text-limt'), 'error');
                } else {
                    FJMessageStore.addMessage(FJLocalStore._('Failed to generate text. Please try again'), 'error');
                }
            })
            .finally(() => {
                setIsLoadingDescription(false);
            });
    };
    const onCreateTitle = () => {
        if (isLoadingText) {
            return;
        }
        setIsLoadingText(true);
        FJRequirementsUtil.eaLog('ai_rewrite_click', { platform: SOCIAL_KEY.YOUTUBE, location: 'title' });
        FJPublishManager.getTextData(SOCIAL_KEY.YOUTUBE, 'title')
            .then(() => {
                const target = FJPublishManager.getPublishTarget(SOCIAL_KEY.YOUTUBE);
                if (target) {
                    setDefaultTitle(target.title);
                }
            })
            .catch(e => {
                if (e.message === '403') {
                    FJMessageStore.addMessage(FJLocalStore._('get-text-limt'), 'error');
                } else {
                    FJMessageStore.addMessage(FJLocalStore._('Failed to generate text. Please try again'), 'error');
                }
            })
            .finally(() => {
                setIsLoadingText(false);
            });
    };

    const isActive =
        isShow &&
        userInfo.linkAccountState === SHARE_BINDING_STATUS.LINKED &&
        selectedShareTypes.includes(SOCIAL_KEY.YOUTUBE);

    if (!isActive) {
        return null;
    }

    return (
        <FJYoutubeView
            data={userInfo}
            onCreateTitle={onCreateTitle}
            onCreateDescription={onCreateDescription}
            defaultTitle={defaultTitle}
            defaultDescription={defaultDescription}
            defaultVisibility={defaultPrivacyState}
            isLoadingText={isLoadingText}
            isLoadingDescription={isLoadingDescription}
        />
    );
};

export default FJYoutubeContainer;
